// extracted by mini-css-extract-plugin
module.exports = {"EmotionCell":"EmotionCell_EmotionCell__2TrF6"};